export default {
  getAccessToken: {
    server: '/live/access-token',
    method: 'get',
  },
  postCtrlPTZ: {
    server: '/live/ctrl-ptz',
    method: 'post',
  },
  postCapture: {
    server: '/live/capture',
    method: 'post',
  },
  getHistoryCaptures: {
    server: '/live/captures',
    method: 'get',
  },
};
